var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOut = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 3.75098V8.61816C7.875 9.11035 7.46484 9.49316 7 9.49316C6.50781 9.49316 6.125 9.11035 6.125 8.61816V3.75098L4.97656 4.87207C4.64844 5.22754 4.07422 5.22754 3.74609 4.87207C3.39062 4.54395 3.39062 3.96973 3.74609 3.6416L6.37109 1.0166C6.69922 0.661133 7.27344 0.661133 7.60156 1.0166L10.2266 3.6416C10.582 3.96973 10.582 4.54395 10.2266 4.87207C9.89844 5.22754 9.32422 5.22754 8.99609 4.87207L7.875 3.75098ZM1.3125 9.49316H3.39062C3.71875 9.49316 4.01953 9.68457 4.15625 9.98535L4.56641 10.7783C4.70312 11.0791 5.00391 11.2432 5.33203 11.2432H8.64062C8.96875 11.2432 9.26953 11.0791 9.40625 10.7783L9.81641 9.98535C9.95312 9.68457 10.2539 9.49316 10.582 9.49316H12.6875C13.3984 9.49316 14 10.0947 14 10.8057V13.4307C14 14.1689 13.3984 14.7432 12.6875 14.7432H1.3125C0.574219 14.7432 0 14.1689 0 13.4307V10.8057C0 10.0947 0.574219 9.49316 1.3125 9.49316Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/out.0a329547705b5a2687aa2bc6a2971729.svg";